import React, { FC } from 'react';
import styles from './index.module.scss';
import { useBiddingGroup, useGroupExpand } from 'src/models/bids/BidFull/hooks';
import TasksGroupTitle from '../TaskGroupTitle';
import classNames from 'classnames';
import { BidQuestionType } from 'src/models/bids/BidFull/types';
import { TasksProvider } from 'src/models/bids/BidFull/providers';
import TasksList from '../TaskList';

interface IProps {
  groupId: string;
}

export const TasksGroup: FC<IProps> = ({ groupId }) => {
  const group = useBiddingGroup(groupId);
  const { isExpanded } = useGroupExpand();

  return group ? (
    <TasksProvider groupId={groupId} skip={!isExpanded} withGenerated={!!group.filePath}>
      <div className={classNames(styles.group, { [styles.isExpanded]: isExpanded })} id={groupId}>
        <TasksGroupTitle groupId={groupId} />
        <div className={classNames(styles.content, { [styles.isExpanded]: isExpanded })}>
          {group.filePath && <TasksList tasksType={BidQuestionType.Generated} />}
          <TasksList tasksType={BidQuestionType.Manual} />
        </div>
      </div>
    </TasksProvider>
  ) : null;
};

export default TasksGroup;
